import JSZip from 'jszip';
import { shouldAddItem } from '../shouldAddItem';
export async function fileItemsFromZip(zipContent, options = {}) {
    const jsZip = new JSZip();
    const zip = await jsZip.loadAsync(zipContent);
    let fileItems = [];
    for (let key in zip.files) {
        const entry = zip.files[key];
        if (entry.dir)
            continue;
        if (!shouldAddItem(entry.name, options.filter))
            continue;
        const item = {
            name: entry.name.replace(/^.*\//, ''),
            relativePath: entry.name,
            lastModified: entry.date.getTime(),
            // @ts-expect-error _data is not exposed because missing for folder   but it is really there
            size: entry._data.uncompressedSize,
            text: () => {
                return entry.async('text');
            },
            arrayBuffer: () => {
                return entry.async('arraybuffer');
            },
            stream: () => {
                return new ReadableStream({
                    start(controller) {
                        void entry.async('arraybuffer').then((arrayBuffer) => {
                            controller.enqueue(arrayBuffer);
                            controller.close();
                        });
                    },
                });
            },
        };
        fileItems.push(item);
    }
    return fileItems;
}
//# sourceMappingURL=fileItemsFromZip.js.map